// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    gridColumnGap: theme.spacing(1),
  },
  titleButton: {
    padding: '0px',
    width: '100%',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff',
    },
    fontWeight: 500,
    fontSize: '1rem',
    justifyContent: 'left',
    textTransform: 'none',
    color: '#4f5a64',
  },
  titleText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '250px',
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputField: {
    '& .MuiInputBase-input': {
      width: '100%',
      padding: '4px',
      background: '#E6E8ED',
      height: '41px',
      fontSize: '1rem',
    },
  },
  errorText: {
    marginLeft: theme.spacing(0.5),
  },
  editControls: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default styles;
